











































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'
import { FETCH_JOB_LIST } from '@/system/store/action-types'
import { IActionType } from '@/system/store'
import { IJob } from '@/features/job/store'
import { jobDetailsLocalisationKeys } from '@/features/job/job.localisation'
import { JOB_DETAILS_NAME } from '@/features/job/job.router'
import { JOB_STATUSES } from '@/constants'

@Component
export default class JobList extends Vue {
  private pagination = {
    rowsPerPage: 0
  }
  private translations = jobDetailsLocalisationKeys
  private progress: number = 1
  private jobStatuses = JOB_STATUSES
  private jobProcessingStatuses = [JOB_STATUSES.VALIDATION_SUCCESS, JOB_STATUSES.TRANSFORMING, JOB_STATUSES.TRANSFORMED]

  @Prop()
  jobs!: IJob[]
  @Action(FETCH_JOB_LIST)
  fetchJobList!: IActionType

  columns = [
    {
      name: 'name',
      field: ({ meta }: IJob) => meta,
      align: 'left'
    },
    {
      name: 'progress',
      field: (job: IJob) => job,
      align: 'left'
    },
    {
      name: 'status',
      field: (job: IJob) => job,
      align: 'left'
    }
  ]

  private isIncludeStatus (status: JOB_STATUSES): boolean {
    return this.jobProcessingStatuses.includes(status)
  }

  private getColor ({ status, meta }: { status: JOB_STATUSES, meta: any }): string {
    if (this.isIncludeStatus(status)) return 'primary'
    if (status === JOB_STATUSES.FAILED) return 'negative'
    return meta.processingErrorsCount ? 'warning' : 'positive'
  }

  private handleClick (job: IJob): void {
    if (![this.jobStatuses.DONE, this.jobStatuses.FAILED].includes(job.status as JOB_STATUSES)) return
    this.$router.push({ name: JOB_DETAILS_NAME, params: { uuid: job.jobId } })
  }
}
